var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","aria-hidden":"true","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-width":"2.8","d":"M1.773 12.559H22.25M1.75 18.5l20.5-.131M1.75 6.5l20.5-.131"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }